import { flatten } from 'lodash';

export const getActiveTab = state => state.activeTab;
export const getDescription = state => state.description;
export const getFilters = state => state.filters;
export const getResults = state => state.results;
export const getFeaturedResults = state => state.featuredResults;
export const getFeaturedTitle = state => state.featuredTitle;
export const getError = state => state.error;
export const getLoading = state => state.loading;
export const getHasNextPage = state => state.hasNextPage;
export const getIncrementPageRequest = state => state.incrementPageRequest;
export const getLastSuccessfulSearch = state => state.lastSuccessfulSearch;
export const getPage = state => state.page;
export const getResultsPerPage = state => state.resultsPerPage;
export const getShouldSearch = state => state.shouldSearch;
export const getSearchInputValue = state => state.searchInputValue;
export const getSelectedFilters = state => state.selectedFilters;
export const getTotalMatches = state => state.totalMatches;
export const isSearchEmpty = state => {
	const isFilterEmpty = getSelectedFilters( state ).every(
		item => 0 === item.length
	);
	return isFilterEmpty && !getSearchInputValue( state );
};

export const hasSelectedFilters = state =>
	0 < flatten( getSelectedFilters( state ) ).length;
